<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false" :apply-text="'Удалить'">
    <div v-if="!loading">
      <v-row no-gutters class="text-center subtitle-1 mt-3" v-if="visitor.length > 0">
        <v-col cols="12" class="font-weight-bold">Список заявок с посетителем</v-col>
      </v-row>
      <v-divider class="grey my-1" v-if="visitor.length > 0"></v-divider>
      <v-data-table
          v-if="visitor.length > 0"
          :headers="headers"
          :items="visitor"
          hide-default-footer
          :items-per-page="visitor.length"
      >
        <template v-slot:item.through_number="props">
          <span v-if="props.item.through_number === null">Заявка создана, но еще не сформирована</span>
          <span v-else >{{props.item.through_number}}</span>
        </template>
      </v-data-table>
      <v-row no-gutters class="text-center subtitle-2 mt-3" v-if="visitor.length > 0">
        <v-col cols="12" class="mb-n3">
          <v-alert type="warning" outlined><strong>Внимание!</strong> Также будут удалены все заявки с посетителем за исключением массовых</v-alert>
        </v-col>
      </v-row>
      <v-row no-gutters class="text-center subtitle-1 mt-3" v-else>
        <v-col cols="12">Вы уверены, что хотите удалить данного посетителя?</v-col>
      </v-row>
    </div>

    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {SemipolarSpinner} from "epic-spinners";

export default {
  name: "VisitorsDeleteDialog",
  props: {
    opened: Boolean,
    visitorData: Number
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    SemipolarSpinner
  },
  data() {
    return {
      loading: true,
      save_loading: false,
      visitor: [],
      headers: [
        {text: "Номер заявки", value: "through_number", sortable: false, align: "start", width: "100%"}
      ]
    }
  },
  computed: {
    form_title () {
      return "Удалить посетителя"
    }
  },
  methods: {
    ...mapActions({
      checkBeforeDeleteVisitors: "admin/checkBeforeDeleteVisitors",
      deleteVisitors: "admin/deleteVisitors"
    }),
    close(){
      this.$emit("close", false)
    },
    loadVisitorsData(){
      this.checkBeforeDeleteVisitors({
        id: this.visitorData,
        finalizer: (data) => {
          this.visitor = data
          this.loading = false
        }
      })
    },
    save(){
      this.save_loading = true
      this.deleteVisitors({
        id: this.visitorData,
        gets: {delete: true},
        finalizer: (val) => {
          this.$emit("close", this.visitor)
          this.save_loading = false
        },
        catcher:(val) => {
          this.mapErrors(val)
          this.save_loading = false
        }
      })
    }
  },
  created() {
    this.loadVisitorsData()
  }
}
</script>

<style scoped>

</style>
}